<div id="chart">
    <mat-icon class="scale" (click)="scale()" matTooltip="Zoom In" *ngIf="!scaled">zoom_in</mat-icon>
    <mat-icon class="scale" (click)="scale()" matTooltip="Zoom Out" *ngIf="scaled">zoom_out</mat-icon>
    <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart"
        [plotOptions]="chartOptions.plotOptions" [labels]="chartOptions.labels"></apx-chart>
</div>
